import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OwnerLeadProfileService } from '../../owner-lead-profile/owner-lead-profile.service';

@Component({
  selector: 'app-bizdev-compose-dialog',
  standalone: false,
  templateUrl: './bizdev-compose-dialog.component.html',
  styleUrls: ['./bizdev-compose-dialog.component.scss']
})
export class BizdevComposeDialogComponent {
  @Input() visible = false;
  @Input() row: any = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() sent = new EventEmitter<{ channel: string; subject: string }>();

  channel: 'EMAIL' | 'SMS' = 'EMAIL';
  subject = '';
  body = '';
  sending = false;
  errorMsg = '';

  constructor(private ownerLeadProfileService: OwnerLeadProfileService) {}

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.reset();
  }

  reset(): void {
    this.subject = '';
    this.body = '';
    this.sending = false;
    this.errorMsg = '';
    this.channel = 'EMAIL';
  }

  send(): void {
    if (!this.body.trim()) return;
    this.sending = true;
    this.errorMsg = '';
    const payload: any = {
      ownerLeadProfileId: this.row?.ownerLeadProfileId,
      channel: this.channel,
      subject: this.channel === 'EMAIL' ? this.subject : null,
      body: this.body
    };
    this.ownerLeadProfileService.compose(payload).subscribe({
      next: () => {
        this.sending = false;
        this.sent.emit({ channel: this.channel, subject: this.subject });
        this.close();
      },
      error: () => {
        this.sending = false;
        this.errorMsg = 'Send failed. Please try again.';
      }
    });
  }
}
